import { ToastPortal } from './ToastPortal/index.js'
import React from 'react'
import { StyledBqToast } from './styles.js'
import PropTypes from 'prop-types'

export const Toast = ({ type, message, open, time = 5000, onBqHide }) => {
  return (
    <ToastPortal>
      <StyledBqToast type={type} open={open} border='m' time={time} onBqHide={onBqHide}>
        <span className="caption">
          {message}
        </span>
      </StyledBqToast>
    </ToastPortal>
  )
}

Toast.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  time: PropTypes.number,
  onBqHide: PropTypes.func
}

export default Toast
